import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'reactstrap';
import CustomerEditDialogHeader from './CustomerViewDialogHeader';
import api from '@/utils/apiClient';
import CustomerViewTabs from './CustomerViewTabs';
import LoadingIcon from 'mdi-react/LoadingIcon';

const CustomerViewDialog = ({ show, onHide, id, rtl }) => {
  const [modal, setModal] = useState({
    isOpen: show,
    title: 'View Customer',
    hide: onHide,
  });

  const [state, setState] = React.useState({
    loading: false,
    customer: {
      name: 'Test Customer 1',
      description: 'any',
    },
    error: '',
  });

  React.useEffect(() => {
    if (id) getCustomerById(+id);
  }, [id]);

  const getCustomerById = async (customerId) => {
    try {
      setState({ ...state, loading: true });
      const { data: res, isSuccess } = await api.customers.getCustomer(customerId);
      if (isSuccess) {
        setState({ ...state, loading: false, customer: res.data, error: '' });
      } else {
        throw new Error(res?.messages?.[0] ?? 'Error while getting customer details');
      }
    } catch ({ message }) {
      setState({ ...state, loading: false, customer: {}, error: message });
      console.error(message);
    }
  };

  const { error, loading, customer } = state;

  return (
    <Modal
      isOpen={show}
      toggle={modal.hide}
      modalClassName={`${rtl.direction}-support`}
      className="modal-dialog--primary modal-dialog--header modal-view-dialog"
    >
      <CustomerEditDialogHeader modal={modal} customer={customer} />
      {/*Customer Modal Body*/}
      <div style={{ padding: 15 }}>
        {loading || !!error ? (
          <>
            {loading && (
              <div className="panel__refresh position-relative" style={{ height: 75 }}>
                <LoadingIcon />
              </div>
            )}
            <div className="text-center">
              {error && (
                <div>
                  <span className="lnr lnr-cross-circle modal__title-icon error" />
                </div>
              )}
              {loading ? 'Getting customer details...' : error}
            </div>
          </>
        ) : (
          <CustomerViewTabs customer={state.customer} />
        )}
      </div>
    </Modal>
  );
};

export default connect((state) => ({
  rtl: state.rtl,
}))(CustomerViewDialog);
